<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select class="Wid120" size="medium" v-model="SystemVal" @change="ReSetPage" clearable placeholder="登录系统">
                    <el-option v-for="i in SystemList" :key="i.id" :label="i.system_name" :value="i.id"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="StateVal" @change="ReSetPage" clearable placeholder="用户状态">
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="AuditVal" @change="ReSetPage" clearable placeholder="审核状态">
                    <el-option label="待审核" value="0"></el-option>
                    <el-option label="已通过" value="1"></el-option>
                    <el-option label="已驳回" value="2"></el-option>
                </el-select>
                <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-badge :value="UserAduitList.length" class="item" v-if="UserAduitList.length>0">
                    <el-button v-throttle  class="BgColor" size="small" type="primary" @click="UserAduitBlon = true">老用户审核</el-button>
                </el-badge>
                <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="danger"
                    @click="Delete('')">批量删除</el-button>
                <el-upload action="none" :show-file-list="false" :http-request="UploadFlie">
                    <el-button v-throttle class="BgColor" size="small" type="primary">批量上传</el-button>
                </el-upload>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增用户</el-button>
                <el-dropdown trigger="click" @command="SeleUser">
                    <el-button v-throttle size="small" type="primary" icon="el-icon-more"></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="DownMol">下载模板</el-dropdown-item>
                        <el-dropdown-item command="DownList">导出列表</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width:100%" class="custom-header-table" @selection-change="SeleChange">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="username" label="账号" min-width="100" />
            <el-table-column prop="name" label="姓名" min-width="100" />
            <el-table-column prop="work_unit" label="工作单位" min-width="200" />
            <el-table-column prop="position" label="职务" min-width="100" />
            <el-table-column prop="title" label="职称" min-width="80" />
            <el-table-column prop="phone" label="电话" min-width="120" />
            <el-table-column prop="email" label="邮箱" min-width="160" />
            <el-table-column label="账号类型" min-width="100">
                <template slot-scope="scope">
                    <div class="BtnHead FlexWrap">
                        <span>{{scope.row.is_expert == 1?'专家':'用户'}}</span>
                        <el-tooltip effect="dark" content="转换" placement="top-start">
                            <i class="el-icon-refresh" @click="ToggleUserType(scope.row)"></i>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="systems" label="可登录项目" min-width="250" align="center">
                <template slot-scope="scope">
                    <div class="BtnHead FlexWrap">
                        <el-tag v-for="item in scope.row.systems" :key="item.system_sub_id" type="success">
                            {{item.system_sub_name || item.system_name}}
                        </el-tag>
                        <el-tag v-if="scope.row.is_expert == 1" type="success">专家</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="审核状态" min-width="80" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.audit_status==1? 'success':scope.row.audit_status==2?'danger':'warning'">
                        {{ scope.row.audit_status==1 ? '通过':scope.row.audit_status==2?'驳回':'待审核' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="关闭/开启" min-width="100" align="center">
                <template slot-scope="scope">
                    <el-switch v-show="scope.row.audit_status==1" v-model="scope.row.status" active-color="#13ce66"
                        inactive-color="#ddd" :active-value="1" :inactive-value="0" @change="ToggleState(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="审核" placement="top-start">
                        <i class="NavIcon el-icon-s-check" @click="ToggleAudit(scope.row)"
                            v-if="scope.row.audit_status==0"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="重置密码" placement="top-start">
                        <i class="NavIcon el-icon-refresh-right" @click="ResetPass(scope.row.id)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <i class="NavIcon el-icon-edit" @click="ToggleDig(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">
                        <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page"
            layout="total,prev,pager,next,sizes" :total="Totol">
        </el-pagination>
        <el-dialog :title="Type=='Add'?'新增用户':'修改用户'" :visible.sync="NewData.NewBlon" width="40%" class="BorderRadius"
            :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">登录系统：</div>
                <el-cascader class="Wid" size="medium" v-model="NewData.system_sub_id" :options="SystemList" :props="{multiple: true,value:'id',label:'system_name',children:'child'}" clearable></el-cascader>
                <!-- <el-select class="Wid" size="medium" v-model="NewData.system_ids" placeholder="可登录系统" multiple>
                    <el-option v-for="item in SystemList" :key="item.id" :label="item.system_name"
                        :value="item.id"></el-option>
                </el-select> -->
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">账号：</div>
                    <el-input class="Wid" :disabled="Type!='Add'" size="medium" placeholder="请输入账号" v-model="NewData.username"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">密码：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入密码" v-model="NewData.password"
                        :disabled="Type!='Add'"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">名称：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入名称" v-model="NewData.name"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">手机号：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入手机号" v-model="NewData.phone"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">工作单位：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入工作单位" v-model="NewData.work_unit"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">科室：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入科室" v-model="NewData.department"></el-input>
                </div>
                
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">职称：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入职称" v-model="NewData.title"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">职务：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入职务" v-model="NewData.position"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">邮箱：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入邮箱" v-model="NewData.email"></el-input>
                </div>
            </div>
            <div class="Line"></div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">账号：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入账号"
                        v-model="NewData.bank_card_number"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">户名：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入户名" v-model="NewData.bank_user_name"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">开户行：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入开户行" v-model="NewData.bank_name"></el-input>
                </div>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">状态：</div>
                <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd"
                    :active-value="1" :inactive-value="0" />
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucData">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="账号审核" :visible.sync="AuditData.AuditBlon" width="25%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">是否通过：</div>
                <el-radio-group v-model="AuditData.AuditVal">
                    <el-radio label="1">通过</el-radio>
                    <el-radio label="2">不通过</el-radio>
                </el-radio-group>
            </div>
            <div class="DigItem" v-if="AuditData.AuditVal==2">
                <div class="DigItemTit">驳回原因：</div>
                <el-input class="Wid" type="textarea" :rows="2" placeholder="请输入内容" v-model="AuditData.AuditRemark">
                </el-input>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(AuditData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="AuditSuc">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="老用户申请系统审批" :visible.sync="UserAduitBlon" width="50%" class="BorderRadius" :before-close="CloseUserAduit">
           <el-table :data="UserAduitList" border stripe class="custom-header-table" height="400">
               <el-table-column prop="user_name" label="申请人" min-width="70" />
               <el-table-column prop="system_name" label="申请系统" min-width="200" />
               <el-table-column prop="create_time" label="提交时间" min-width="120" />
               <el-table-column label="操作" min-width="100" align="center">
                   <template slot-scope="scope">
                        <el-button v-throttle class="BgColor" size="small" type="primary" @click="UserAduitSuc(1,scope.row)">通过</el-button>
                        <el-button v-throttle class="BgColor" size="small" type="danger" @click="UserAduitSuc(2,scope.row)">不通过</el-button>
                   </template>
               </el-table-column>
           </el-table>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "",
        data() {
            return {
                SearchVal: "",
                SystemVal:"",
                AuditVal:"",
                StateVal:"",
                Data: [],
                SeleId: [],
                Page: 1,
                PageSize: 10,
                Totol: 0,
                Type: 'Add',
                SystemList: '',
                NewData: {
                    id: '',
                    NewBlon: false,
                    username: "",
                    password: "",
                    name: "",
                    phone: "",
                    email: "",
                    system_sub_id: "",
                    status: 0,
                    bank_card_number: "",
                    bank_name: "",
                    bank_user_name: "",
                    work_unit: "",
                    department:"",
                    position: "",
                    title: "",
                },
                AuditData: {
                    id: "",
                    AuditBlon: false,
                    AuditVal: "1",
                    AuditRemark: "",
                },
                UserAduitList:[],
                UserAduitBlon:false,
                
            };
        },
        mounted() {
            this.SystemList = JSON.parse(this.$Tools.localData("SystemMenu"));
            this.GetData();
            this.GetAduitData();
        },
        methods: {
            GetData() {
                this.$get('/admin/user/index', {
                    keyword: this.SearchVal,
                    system_id:this.SystemVal,
                    audit_status:this.AuditVal,
                    status:this.StateVal,
                    page: this.Page,
                    page_size: this.PageSize,
                }).then(res => {
                    if (res) {
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetAduitData() {
                this.$get('/admin/apply/index', {
                    status:"0",
                    page: "1",
                    page_size: "1000",
                }).then(res => {
                    if (res) {
                        this.UserAduitList = res.data.list;
                    }
                })
            },
            SeleUser(type) {
                if (type == "DownMol") {
                    this.DownMol()
                };
                if (type == "DownList") {
                    this.DownUser()
                };
            },
            ToggleAudit(row) {
                this.AuditData.id = row.id;
                this.AuditData.AuditBlon = true;
            },
            ToggleDig(row) {
                this.$Tools.ResetData(this.NewData)
                if (row != 'Add') {
                    this.Type = 'Edi';
                    this.NewData.id = row.id;
                    this.NewData.username = row.username;
                    this.NewData.password = row.password;
                    this.NewData.name = row.name;
                    this.NewData.phone = row.phone;
                    this.NewData.email = row.email;
                    this.NewData.system_sub_id = row.system_sub_data;
                    this.NewData.bank_card_number = row.bank_card_number;
                    this.NewData.bank_name = row.bank_name;
                    this.NewData.bank_user_name = row.bank_user_name;
                    this.NewData.work_unit = row.work_unit;
                    this.NewData.position = row.position;
                    this.NewData.title = row.title;
                    this.NewData.status = row.status;
                    this.NewData.department = row.department;
                } else {
                    this.Type = 'Add';
                }
                this.NewData.NewBlon = true;
            },
            SucData() {
                var Url = this.Type == 'Add'?'/admin/user/save':'/admin/user/update'
                this.$post(Url,this.NewData).then(res => {
                    if (res) {
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            ToggleState(row) {
                if(!row.status){
                    this.$prompt('请输入关闭原因', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(({
                        value
                    }) => {
                        this.SetState(row)
                    }).catch(() => {
                        row.status = 1;
                    });
                }else{
                    this.SetState(row)
                }
            },
            SetState(row){
                this.$post('/admin/user/changeStatus', {
                    ids: [row.id],
                    status: row.status,
                }).then(res => {
                    if (res) {
                        this.$message.success("修改成功!");
                        this.GetData();
                    }
                })
            },
            ToggleUserType(row) {
                this.$confirm("此操作会将" + (row.is_expert == 1 ? '专家' : '用户') + "账号转为" + (row.is_expert != 1 ? '专家' :
                    '用户') + "账号", "提示", {
                        type: "warning"
                    }).then(() => {
                    this.$get('/admin/user/expert', {
                        id: row.id,
                    }).then(res => {
                        if (res) {
                            this.$message.success("修改成功!");
                            this.GetData();
                        }
                    })
                })
            },
            ResetPass(id) {
                this.$confirm("此操作将重置用户密码, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$post('/admin/user/resetPassword', {
                        id: id,
                    }).then(res => {
                        if (res) {
                            this.$message.success(res.msg);
                            this.GetData();
                        }
                    })
                })
            },
            SeleChange(val) {
                this.SeleId = val.map(item => item.id);
            },
            Delete(id) {
                var Ids = id != "" ? [id] : this.SeleId;
                this.$confirm("此操作将永久删除用户, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/user/delete', {
                        ids: Ids,
                    }).then(res => {
                        if (res) {
                            this.$message.success(res.msg);
                            this.GetData();
                        }
                    })
                })
            },
            AuditSuc() {
                this.$post('/admin/user/audit', {
                    id: this.AuditData.id,
                    audit_status: this.AuditData.AuditVal,
                    reject_reason: this.AuditData.AuditRemark,
                }).then(res => {
                    if (res) {
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.AuditData)
                    }
                })
            },
            UserAduitSuc(t,row){
                if(t==2){
                    this.$prompt('请输入不通过原因', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(({value}) => {
                        this.SetUserAduit(t,row,value)
                    })
                }else{
                    this.SetUserAduit(t,row)
                }
                this.GetData();
            },
            SetUserAduit(t,r,v=''){
                this.$get("/admin/apply/operation",{
                    id:r.id,
                    is_status:t,
                    reason:v,
                }).then((res) => {
                    this.$message.success(res.msg);
                    this.GetAduitData();
                })
            },
            UploadFlie(res) {
                var file = res.file;
                if (this.$Tools.ChangeExcel(file)) {
                    this.$message.error('只能上传Excel文件格式 (.xls, .xlsx, .xlsm, .xlsb)');
                    return false;
                }
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    var fd = new FormData()
                    fd.append('file', file);
                    this.$post("/admin/user/import", fd, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res) => {
                        loading.close();
                        this.$message.success(res.msg);
                        this.GetData();
                    })
                } catch (error) {
                    loading.close();
                }
            },
            DownUser() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    this.$get('/admin/user/export').then(res => {
                        loading.close();
                        if (res) {
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            DownMol() {
                // window.open(this.$Tools.ServeUrl() + '/common/download/template/user.xlsx')
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    this.$get('/user/download').then(res => {
                        loading.close();
                        if (res) {
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            CloseUserAduit(done){
                done();
            },
            ReSetPage() {
                this.Page = 1;
                this.GetData();
            },
            SizeChange(val) {
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val) {
                this.Page = val;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    .el-icon-refresh {
        color: #095b95;
        cursor: pointer;
    }
</style>